import gql from "graphql-tag";

export default gql`
  query TrendingGovernments($limit: Int = 10) {
    trendingGovernments(limit: $limit) {
      _id
      slug
      name
      logo
      city {
        _id
        name
        state
        country
        stateName: state(full: true)
        type
        county
      }
      isFollowing
    }
  }
`;
